import React from "react";
import ProgressBar from "../../ProgressBar/ProgressBar";
import { Col, Row, Typography } from "antd";
import { Card } from "antd";
import "./EmissionCategory.css";
import Loader from "../../Loader/Loader";
const { Text } = Typography;

const EmissionCategory = ({ emissionCategoryData, isLoading }) => {
  const hasData =
    Array.isArray(emissionCategoryData?.resources) &&
    emissionCategoryData.resources.length > 0;

  return (
    <Card className="emission-card">
      <Row>
        <Col className="title-emission-container" xs={24}>
          <span className="title-emission-category">Emission per Category</span>
        </Col>
      </Row>
      {isLoading ? (
        <Loader />
      ) : !hasData ? (
        <div className="no-results-container">
          <Text className="no-data-message">No results found.</Text>
        </div>
      ) : (
        emissionCategoryData.resources.map((emission, i) => {
          return (
            emission.name !== "NULL" && (
              <Row key={i} className="emission-container" gutter={16}>
                <Col className="item-text-container" span={12}>
                  <Text className="item-text">{`${emission.name} (${emission.quantity} ton CO₂)`}</Text>
                </Col>
                <Col className="progress-bar-container" span={12}>
                  <ProgressBar
                    percentSecond={emission.percent}
                    percent={emission.percent}
                  />
                </Col>
              </Row>
            )
          );
        })
      )}
    </Card>
  );
};

export default EmissionCategory;
